<template>
  <VRegisterApp name="colleague" @mounted="handleMounted" :workbench="workbench" @next="handleNext">
    <div style="margin-bottom: 20px" v-if="pageConfig.config.NeedOrder">
      <vxe-table ref="tableRefs" :data="tableData" :border="'inner'" align="center">
        <vxe-column field="TicketName" :title="$t(`registration.payment.table-code`)" min-width="200"></vxe-column>
        <vxe-column field="TicketPrice" :title="$t(`registration.payment.table-price`)" width="80"></vxe-column>
        <vxe-column field="Number" :title="$t(`registration.payment.table-number`)" width="80"></vxe-column>
        <vxe-column field="Total" :title="$t(`registration.payment.table-money`)" width="80"></vxe-column>
        <vxe-column field="Status" :title="$t(`registration.payment.table-status`)" width="100">
          <template #default="{ row }">
            <template v-if="(row.Status || '').toLocaleLowerCase() === 'ready'">
              <template v-if="(row.OrderStatus || '').toLocaleLowerCase() === 'approval'">{{ $t(`registration.payment.status-approval`) }}</template>
              <template v-else>{{ $t(`registration.payment.status-pending`) }}</template>
            </template>
            <template v-else>{{ $t(`registration.payment.status-paid`) }}</template>
          </template>
        </vxe-column>
        <vxe-column :title="$t(`registration.payment.table-operation`)" width="100" align="center">
          <template #default="{ row }">
            <template v-if="(row.Status || '').toLocaleLowerCase() === 'ready'">
              <template v-if="(row.OrderStatus || '').toLocaleLowerCase() === 'approval'">
                <el-button link type="primary" @click="handleCancelOrder(row)">{{ $t(`registration.payment.cancel`) }}</el-button>
              </template>
              <template v-else>
                <el-button link type="primary" @click="handleCancelOrder(row)">{{ $t(`registration.payment.cancel`) }}</el-button>
              </template>
            </template>
          </template>
        </vxe-column>
      </vxe-table>
    </div>
    <el-form :scroll-to-error="true" ref="formRefs" :model="form" label-width="120px" label-position="top">
      <el-card class="participant" v-for="it in colleagueData.ticket" :key="it.Code" :header="it.Name">
        <div style="margin-bottom: 20px">
          <el-checkbox v-model="it.participant" :disabled="it.disabled" @change="(val) => handleParticipant(it, val)">{{ $t('registration.colleague.participant') }}</el-checkbox>
        </div>
        <template v-for="(form, index) in it.forms" :key="index">
          <v-from
            :ref="setItemRefs"
            v-model="it.forms[index]"
            :fields="pageConfig.fields"
            :questions="questions"
            :need-question="pageConfig.config.CopyCodeFromParent"
            :title="$t('registration.colleague.seq', { num: index + 1 })"
          />
        </template>
      </el-card>
    </el-form>

    <div v-if="workbench" style="display: flex; justify-content: center; padding: 24px">
      <el-button class="next" type="primary" @click="handleNext">{{ $t('registration.btn.next') }}</el-button>
    </div>
  </VRegisterApp>
</template>

<script setup>
  import VRegisterApp from '../app/index.vue'
  import VFrom from './form.vue'
  import { onMounted, ref, inject, computed } from 'vue'
  import { ArrowDown, ArrowUp } from '@element-plus/icons-vue'
  import { useRouter } from 'vue-router'
  import { colleague, getColleague } from '@/api/registration'
  import { getPageConfig } from '@/api/config'
  import { getOrderList, cancelOrder, payment } from '@/api/registration'

  import { ElMessage, ElMessageBox, ElLoading } from 'element-plus'
  import { useI18n } from 'vue-i18n'

  const props = defineProps({
    workbench: {
      type: Boolean,
      default: false,
    },
  })

  const { t, te } = useI18n()

  const router = useRouter()
  const pageConfig = ref({})
  const form = ref({})
  const formRefs = ref([])
  const formItemRefs = ref([])
  const information = ref({})
  const tableData = ref([])
  const colleagueData = ref({ colleague: [], ticket: [] })
  const colleagueTicket = ref([])
  const questions = ref([])

  const $steps = inject('$steps')
  const current = computed(() => {
    for (var g of $steps.value) {
      if (g.Name == 'colleague') {
        return g
      }
    }
    return null
  })

  const setItemRefs = (el) => {
    console.log('setRefs', el)
    if (el) {
      formItemRefs.value.push(el)
    }
  }

  const handleMounted = async (val) => {
    pageConfig.value = val.pageConfig
    information.value = val.information
    form.value = information.value.data
    //
    await fetchData()
  }

  const handleParticipant = (it, val) => {
    let uid = information.value.data.UserID
    if (val) {
      //console.log('handleParticipant',val)
      //it.forms[0] = colleagueData.value.colleague[uid] //移动到第一位
      let u = it.UserID.find((x) => x.UserID == uid)
      console.log(it,uid,u)
      for (var i = 0; i < it.forms.length; i++) {
        if (it.forms[i].UserID.indexOf('_') ==0) {
          //u._.Disabled=true;
          console.log('------------------------------------')
          it.forms.splice(i, 1)
          let curr={
            ...colleagueData.value.colleague[uid],
            //...{ _: { Disabled: true } },
            _: u || { Paid: false },
          }
          curr._.Disabled=true;
          it.forms.unshift(curr) //移动到第一位
          console.log(it.forms)
          break
        }
      }
    } else {
      var index = it.forms.findIndex((x) => x.UserID == uid)
      if (index >= 0) {
        //找到当前记录，并清空
        it.forms[index] = { UserID: '_' + new Date().getTime(), Question: { data: {} } }
      }
    }
  }

  const fetchData = async () => {
    //
    const { data: survey } = await getPageConfig('survey')
    //
    questions.value = (survey.questions || []).map((data) => {
      var it = { ...data, clear: false }
      let val = data.control
      let max = data.maxNumber || 0
      let hasText = data.options.some((item) => item.text === true)
      if (!((val === 'select' && !hasText) || (data.options.length == 1 && data.options[0].text))) {
        it.clear = true
      }
      return it
    })


    const { data: o } = await getOrderList()
    tableData.value = o
    //
    const { data } = await getColleague()
    colleagueData.value = data
    //colleagueTicket.value = data.ticket
    let uid = information.value.data.UserID
    //生成对应的用户数据
    for (var g of colleagueData.value.ticket) {
      let forms = []
      for (var u of g.UserID) {
        let o = { UserID: '_' + new Date().getTime(), Question: { data: {} } }
        for (var x of questions.value) {
          o.Question.data[x.id] = {}
        }
        forms.push({ ...(colleagueData.value.colleague[u.UserID] || o), _: { ...u } })
      }
      console.log(' g.UserID.length', g.UserID.length)
      for (var u = g.UserID.length; u < g.Number; u++) {
        let o = { UserID: '_' + new Date().getTime(), Question: { data: {} } }
        for (var x of questions.value) {
          o.Question.data[x.id] = {}
        }
        forms.push({ ...o, _: { Paid: false, Status: 'TBC' } })
      }
      console.log('forms', forms)
      g.participant = forms.findIndex((x) => x.UserID === uid) >= 0
      g.disabled = false
      if (g.participant) {
        let index = forms.findIndex((x) => x.UserID === uid)
        let o = colleagueData.value.colleague[uid]
        if (index >= 0) {
          o = forms[index]
          o._.Disabled = true
          console.log('Disabled',o)
          forms.splice(index, 1)
        }
        forms.unshift(o) //移动到第一位
        g.disabled = true || (o._ && (o._.Paid || o._.Status == 'CFM')) //已支付的禁用
      } else {
        //如果没有，则找一个空的值，并置顶
        for (var i = 0; i < forms.length; i++) {
          if (forms[i].UserID.indexOf('_') === 0) {
            console.log('------------------------------------')
            forms.splice(i, 1)
            forms.unshift({ UserID: '_' + new Date().getTime(), Question: { data: {} }, _: { Paid: false } }) //找到一个空的
            break
          }
        }
      }
      g.forms = forms
    }
  }

  const handleCancelOrder = (row) => {
    ElMessageBox.confirm(t(`registration.payment.cancel-confirm`), 'Warning', {
      type: 'warning',
    })
      .then(async () => {
        const loadingInstance = ElLoading.service({ fullscreen: true })
        try {
          const { ret } = await cancelOrder(row.ID)
          ElMessage({ message: t(`registration.payment.cancel-ok`), type: 'success' })
          await fetchData()
        } catch (e) {}
        loadingInstance.close()
      })
      .catch(() => {})
  }

  const handleNext = async () => {
    let success = 0
    for (var g of formItemRefs.value) {
      const { valid, fields } = await g.validate()
      if (!valid) {
        for (var g in fields) {
          ElMessage({
            message: fields[g][0].message + '',
            type: 'error',
          })
          break
        }
        return
      }
    }
    const loadingInstance = ElLoading.service({ fullscreen: true })
    let ticket = {}
    for (var g of colleagueData.value.ticket) {
      ticket[g.Code] = g.forms
    }
    try {
      const { data } = await colleague(ticket)

      if (props.workbench) {
        router.push({ name: 'personalcenter-order' })
      } else {
        router.push({ name: data.to })
      }
    } catch (e) {
      //ElMessage({ message: e.msg, type: 'error' })
    }
    loadingInstance.close()
  }
</script>

<style lang="scss" scoped>
  .el-card {
    &.participant {
      background: #fff;
      border-radius: 12px;
      box-shadow: none;
      border-width: 1px !important;
      margin-bottom: 20px;
      border-color: var(--el-color-primary-light-8);
      :deep() {
        > .el-card__header {
          background-color: var(--el-color-primary-light-8);
          border-bottom: solid 1px var(--el-color-primary-light-8);
          font-weight: bold;
          font-size: 12px;
        }
        > .el-card__body {
          .el-card {
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  .vxe-table {
    :deep() {
      .vxe-table--header-wrapper {
        background-color: #f1f4f9;
        th.el-table__cell {
          height: 56px;
        }
      }
      .vxe-table--body-wrapper {
        .vxe-body--column {
          background-image: linear-gradient(#f0f0f0, #f0f0f0);
        }
      }
      .vxe-table--border-line {
        border: solid 1px #f0f0f0;
      }
    }
    .el-button + .el-button {
      margin-left: 3px;
    }
  }
</style>
